import { z } from 'zod';

import { schemaTrackingObjectPart } from '../Tracking';

export const AttributionResponseData = z.object({
    domain: z.string().nullish(),
    firstPartyId: z.string().nullish(),
    geoCity: z.string().nullish(),
    geoCountry: z.string().nullish(),
    hitTS: z
        .object({
            value: z.string().nullish(),
        })
        .optional(),
    referrer: z.string().nullish(),
    requestedUrl: z.string().nullish(),
    requestId: z.string().nullish(),
    sessionId: z.string().nullish(),
    source: z.string().nullish(),
    testTraffic: z.boolean().nullish(),
    userAgent: z.string().nullish(),
});

export const Attribution = schemaTrackingObjectPart.extend({
    ...AttributionResponseData.shape,
    advisor: z.string().nullish(),
    bucket: z.string().nullish(),
    loanRequestId: z.string(),
});

export type Schema_Attribution = z.infer<typeof Attribution>;
